import React from 'react';
export function SiteBannerIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M19 16H5v3h14v-3z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 1H1v22h22V1zM4.5 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM21 8H3v13h18V8z"
  }));
}